import { EMPTY } from "rxjs";
import { filter, retry, switchMap } from "rxjs/operators";
import { selectPlayerInfo } from "../../../selectors/selectPlayerInfo";
import { CommandCode, } from "../../../utils/network/generated/protoTypes";
import { PersistenceMode } from "../../../utils/PersistenceMode";
import { utilPersistence } from "../../../utils/utilPersistence";
import { TypeServerPersistenceInfo, } from "../actionServerPersistence";
export var epicRemoveServerPersistenceKeys = function (action$, state$, deps) {
    return action$.pipe(filter(function (action) {
        return action.type === TypeServerPersistenceInfo.RemoveServerPersistence &&
            action.keysToRemove.length > 0;
    }), switchMap(function (action) {
        var keysToRemove = action.keysToRemove;
        keysToRemove.forEach(function (keyValPair) {
            if (keyValPair.key !== undefined) {
                utilPersistence.setValue(keyValPair.key, {}, PersistenceMode.Reset);
            }
        });
        return deps.netSend({
            id: CommandCode.PlayerPreferencesStorage,
            props: {
                keysToRemove: keysToRemove,
                playerId: selectPlayerInfo(state$.value).playerId,
            },
        });
    }), retry(), switchMap(function () { return EMPTY; }));
};



//////////////////
// WEBPACK FOOTER
// ./src/features/server-persistence/epics/epicRemoveServerPersistenceKeys.ts
// module id = 2327
// module chunks = 3